import React from 'react';
import { Field } from 'react-form';

import InfoButton from '../../InfoButton';

import styles from '../Input/Input.scss';
import { formatDecimal } from '../../../utils/formatting';

const InputGroupPreContent = (props) => {
    const {
        fieldApi,
        onChange,
        onBlur,
        field,
        validate,
        id,
        label,
        hiddenLabel,
        description,
        pre,
        disabled,
        hoverText,
        className,
        themeV3,
        format,
        'data-testid': dataTestId,
        ...rest
    } = props;

    const { value, error, warning, touched, setValue, setTouched } = fieldApi;
    const initialFormatDone = React.useRef(false);

    React.useEffect(() => {
        if (format === 'decimal' && !initialFormatDone.current && value != null && value !== '') {
            const formatted = formatDecimal(value);
            if (formatted !== value) {
                setValue(formatted);
            }
            initialFormatDone.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const inputProps = {
        ...rest,
        id,
        className: `form-control ${styles.formControl} ${className}`,
        value: value === 0 ? 0 : value || '',
        onChange: e => {
            setValue(e.target.value);
            if (onChange) {
                onChange(e.target.value, e);
            }
        },
        onBlur: e => {
            setTouched();
            if (onBlur) {
                onBlur(e);
            }
        },
    };

    return (
        <div className={`form-group form-group-xl ${styles.formInput} ${(touched && error) && 'is-invalid'} ${description && 'description'} ${themeV3 ? styles.themeV3 : ''} mb0`} data-testid={dataTestId || undefined}>
            {!themeV3 && !!label && (
                <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                    {label}
                    {hoverText && <InfoButton hoverText={hoverText} data-testid={id ? `${id}.info-btn` : undefined} />}
                </label>
            )}
            {description && (<small>{description}</small>)}
            {themeV3 ? (
                <div className="input-wrapper">
                    <pre>{pre}</pre>
                    <input {...inputProps} disabled={disabled} />
                    <label>{label} {hoverText && <InfoButton hoverText={hoverText} />}</label>
                </div>
            ) : (
                <div className="input-wrapper">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="inputGroup-sizing-default">{pre}</span>
                        </div>
                        <input {...inputProps} disabled={disabled} />
                    </div>
                    <div className="error-indicator" />
                </div>
            )}
            {touched &&
                ((error && <div className="invalid-feedback">{error}</div>) ||
                    (warning && <div className="warning-feedback">{warning}</div>))}
        </div>
    );
};

const InputGroupPre = props => (
    <Field field={props.field} validate={props.validate}>
        {fieldApi => <InputGroupPreContent fieldApi={fieldApi} {...props} />}
    </Field>
);

export default InputGroupPre;
